import { articleList } from "@/mocks/articles";

export default function ArticleGrid() {
  const previewArticles = articleList.slice(1, 10);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold bg-primary-100 text-primary-800 uppercase tracking-wider mb-4">
            Expert Guides
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Pandabuy Spreadsheet{" "}
            <span className="text-primary-500">Guides & Tips</span>
          </h2>
          <p className="mt-3 text-foreground-600 max-w-[560px] mx-auto text-sm md:text-base">
            In-depth articles to help you master pandabuy spreadsheet shopping — from beginner basics to expert strategies
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {previewArticles.map((article) => (
            <a
              key={article.slug}
              href={`/article/${article.slug}`}
              className="group flex flex-col rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 cursor-pointer transition-all duration-300 hover:translate-y-[-4px]"
            >
              <div className="relative h-[180px] md:h-[190px] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-[10px] font-semibold bg-background-50/90 text-foreground-800 whitespace-nowrap backdrop-blur-sm">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading font-semibold text-foreground-950 text-base leading-snug line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-4 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-200/40">
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                  <span className="flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                    Read More
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}